import React from 'react';

export interface SegmentedOption<T extends string> {
  value: T;
  label: React.ReactNode;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  size?: 'sm' | 'lg';
  onChange: (value: T) => void;
}

export default function SegmentedControl<T extends string>({ options, value, size = 'lg', onChange }: SegmentedControlProps<T>) {
  const sizeClass = size === 'sm' ? 'btn-sm py-1' : 'py-2 px-3';

  return <div className="d-inline-flex border rounded overflow-hidden" role="radiogroup">
    {options.map((option, index) => {
      const active = option.value === value;
      const borderClass = index > 0 ? 'border-start ' : '';
      const activeClass = active ? 'bg-soft-primary text-primary' : 'btn-ghost-secondary text-dark';
      return <button
        key={option.value}
        type="button"
        role="radio"
        aria-checked={active}
        className={`btn ${sizeClass} d-inline-flex align-items-center gap-1 border-0 rounded-0 fw-semibold text-nowrap ${borderClass}${activeClass}`}
        onClick={() => onChange(option.value)}>
        {active && <i className="bi-check2 small" />}
        {option.label}
      </button>
    })}
  </div>;
}
